/**
 * Pairs dashboard section.
 */

import * as React from 'react';
import { PairsDataTable } from '@/components/pairs/inperson/PairsDataTable';
import { usePageActions } from '@/hooks/usePageActions';
import type { ElementWidth } from '@/types/interface-elements.types';

/** Props for {@link PairsSection}. */
interface PairsSectionProps {
  layoutWidth?: ElementWidth;
  expandedRowId?: string | null;
  onToggleRow?: (id: string) => void;
  onCloseDetails?: () => void;
}

/** Dashboard widget: in-person pairs list. */
export const PairsSection: React.FC<PairsSectionProps> = ({
  layoutWidth = 'full',
  expandedRowId,
  onToggleRow,
  onCloseDetails,
}) => {
  const { canExportCsv } = usePageActions('pairs');

  return (
    <PairsDataTable
      layoutWidth={layoutWidth}
      isSection={true}
      expandedRowId={expandedRowId}
      onToggleRow={onToggleRow}
      onCloseDetails={onCloseDetails}
      pageActions={{ canExportCsv }}
    />
  );
};
